import { ZPAR_FAQS } from './ZPAR_FAQS';
import { MX_FAQS } from './MX_FAQS';
import { UBPE_FAQS } from './UBPE_FAQS';

const siteId = process.env.REACT_APP_BUILD_SITE;

const getAsksAndAnswer = () => {
  if (siteId === 'ZPAR') return ZPAR_FAQS;
  if (siteId === '24MX') return MX_FAQS;
  if (siteId === 'UBPE') return UBPE_FAQS;

  return null;
};

const asksAndAnswers = getAsksAndAnswer();

export { asksAndAnswers };
